import isEmpty from 'lodash/isEmpty';

import { IntegrationSystem } from '@/shared/types';

import { DocumentType, DocumentTypeEntity } from '@/api/types';

import api from '@/api';

import { reformatDocumentTypeToEntity } from '../../../helpers/reformatDocumentTypeToEntity';

export const getERZDocumentTypeEntites = async (
  allowedDocumentTypeCodes: Array<DocumentType<IntegrationSystem.ERZ>['code']> = [],
  disallowedDocumentTypeKinds: Array<DocumentType<IntegrationSystem.ERZ>['kind']> = [],
  disallowedDocumentTypeCodes: Array<DocumentType<IntegrationSystem.ERZ>['code']> = [],
): Promise<Array<DocumentTypeEntity<IntegrationSystem.ERZ>>> => {
  let documentTypes = (await api.erz.dictionary.getDocumentTypes()).data;

  if (!!allowedDocumentTypeCodes?.length) {
    documentTypes = allowedDocumentTypeCodes.reduce(
      (accumulator, documentTypeCode) => {
        const wantedDocumentType = documentTypes.find(
          (documentType) => documentType.code !== null && documentType.code === documentTypeCode,
        );

        return isEmpty(wantedDocumentType) ? accumulator : [...accumulator, wantedDocumentType];
      },
      [] as Array<DocumentType<IntegrationSystem.ERZ>>,
    );
  }

  if (!!disallowedDocumentTypeKinds?.length || !!disallowedDocumentTypeCodes?.length) {
    documentTypes = documentTypes.filter(
      (documentType) =>
        !disallowedDocumentTypeKinds?.includes(documentType.kind) &&
        !disallowedDocumentTypeCodes.includes(documentType.code),
    );
  }

  const entities = documentTypes.map(reformatDocumentTypeToEntity);

  return entities;
};
